/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.static.js":
 *
 * The vendor.static.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.static.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function () {
  // Sélectionne tous les éléments avec la classe 'product__media-item'
  var mediaItems = document.querySelectorAll('.product__media-item');

  // Ajoute un événement 'click' à chaque élément
  mediaItems.forEach(function (item) {
    item.addEventListener('click', function () {
      // Si l'élément cliqué n'a pas la classe 'is-selected'
      if (!this.classList.contains('is-selected')) {
        // Supprime la classe 'is-selected' de tous les éléments
        mediaItems.forEach(function (el) {
          el.classList.remove('is-selected');
        });
        // Ajoute la classe 'is-selected' à l'élément cliqué
        this.classList.add('is-selected');
      }
    });
  });

  // si on trouve des .color_alternatives span, on vérifie la luminosité de la couleur et on passe le span en question en argument
  if ($('.plp_paired_colors span').length) {
    $('.plp_paired_colors span').each(function () {
      checkColor(this, $(this).css('background-color'));
    });
  }
});

// Changement de variante
document.addEventListener('variant:changed', function (event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let currentVariant = variant.id;
  renderPrecommandes(currentVariant);
  renderQuantityLeft(currentVariant);
});

/* Au changement de variante, on re-render la section  */
function renderPrecommandes(currentVariant) {
  fetch(window.location.pathname + "?section_id=precommandes-ajax&variant=" + currentVariant)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      //console.log(html);

      const precommandeOrigine = document.getElementById(`js_pdp_precommandes`);
      const precommandeDestination = html.getElementById(`js_pdp_precommandes`);

      if (precommandeOrigine && precommandeDestination) {
        precommandeOrigine.innerHTML = precommandeDestination.innerHTML;
      }
    });
}

function renderQuantityLeft(currentVariant) {
  fetch(window.location.pathname + "?section_id=quantity-left-ajax&variant=" + currentVariant)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const source = html.getElementById('js_pdp_quantity_left');
      const target = document.querySelector('[id^="Quantity-Left-"]');
      if (source && target) {
        target.innerHTML = source.innerHTML;
      }
    });
}

// Fonction pour calculer la luminosité perçue
function getLuminance(r, g, b) {
  // Convertir les valeurs RGB en luminance perçue
  const a = [r, g, b].map(function (v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  // Formule de luminosité relative
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

// Fonction pour vérifier si la couleur est trop claire
function isColorTooLight(hexColor) {
  const rgb = hexColor.match(/\d+/g).map(Number);
  const luminance = getLuminance(rgb[0], rgb[1], rgb[2]);
  return luminance > 0.8;
}

// Fonction principale pour appliquer la classe si nécessaire
function checkColor(dot, hexColor) {
  if (isColorTooLight(hexColor)) {
    dot.classList.add('bordered');
  }
}

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
$(document).ready(function () {
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    if (url && url !== "#") {
      window.location.href = url;
    }
  });
});
